const StorageUtils = {
    /**
     * Save an object or array to storage
     * @param {string} key - The key under which the data will be stored.
     * @param {object|array} value - The data to store.
     * @param {boolean} [useSession=false] - Use sessionStorage instead of localStorage.
     */
    save(key, value, useSession = false) {
        const storage = useSession ? sessionStorage : localStorage;
        try {
            storage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error('Error saving to storage', error);
        }
    },

    /**
     * Retrieve an object or array from storage
     * @param {string} key - The key of the data to retrieve.
     * @param {boolean} [useSession=false] - Use sessionStorage instead of localStorage.
     * @returns {object|array|null} - The stored data or null if not found.
     */
    get(key, useSession = false) {
        const storage = useSession ? sessionStorage : localStorage;
        try {
            const item = storage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.error('Error reading from storage', error);
            return null;
        }
    },

    add(key, value, useSession = false) {
        const item = this.get(key, useSession);
        const Newitem = {
            ...item,
            ...value
        }
        this.save(key, Newitem, useSession);
    },

    /**
     * Remove data from storage
     * @param {string} key - The key of the data to remove.
     * @param {boolean} [useSession=false] - Use sessionStorage instead of localStorage.
     */
    remove(key, useSession = false) {
        const storage = useSession ? sessionStorage : localStorage;
        try {
            storage.removeItem(key);
        } catch (error) {
            console.error('Error removing from storage', error);
        }
    },
};

export default StorageUtils;
